module.exports = __webpack_public_path__ + "img/c_gcc.56ac86a4.jpg";